import { createSlice } from '@reduxjs/toolkit';
import { SettingsState } from '../data/interfaces/settingsmodel';


// Define the initial state using that type
const initialState: SettingsState = {
  Toc: null,
  Environment:null,
  Database:null,
  Role:null
}
export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    updatetoc: (state,action) => {
      state.Toc=action.payload;
    },
    updateenvironment: (state,action) => {
      state.Environment=action.payload;
    },
    updatedatabase: (state,action) => {
      state.Database=action.payload;
    },
    updaterole: (state,action) => {
      state.Role=action.payload;
    }
  },
});

export const { updatetoc,updatedatabase,updateenvironment,updaterole } = settingsSlice.actions

export default settingsSlice.reducer